import { render, staticRenderFns } from "./itemBatchesTable.vue?vue&type=template&id=8df5c158&"
import script from "./itemBatchesTable.vue?vue&type=script&lang=ts&"
export * from "./itemBatchesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports